import React from 'react';
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { AuditLogProvider } from '@core/audit';
import { BrandDocumentHead, Toaster } from '@core/components';
import { AuthProvider } from '@core/contexts/AuthContext';
import { BrandProvider } from '@core/contexts/BrandContext';
import { QueryProvider } from '@core/contexts/QueryProvider';
import { ThemeProvider } from '@core/contexts/ThemeContext';
import { AuthGuard, Login } from '@core/pages';
import { BRAND } from '../brand';
import './App.css';
import { LEITOURGOS_AUDIT_LOG_RENDERERS } from './audit/registerRenderers';
import LeitourgosLayout from './components/LeitourgosLayout';
import { AppProvider } from './context/AppContext';
import { navItems } from './navigation';

const App: React.FC = () => {
  return (
    <BrandProvider value={BRAND}>
      <AuditLogProvider renderers={LEITOURGOS_AUDIT_LOG_RENDERERS}>
        <BrandDocumentHead />
        <ThemeProvider>
          <CssBaseline />
          <Toaster position="top-center" />
          <QueryProvider>
            <AuthProvider>
              <Router>
                <div className="App">
                  <Routes>
                    {/* Public routes */}
                    <Route path="/login" element={<Login />} />
                    {/* Protected routes */}
                    <Route
                      path="/*"
                      element={
                        <AuthGuard>
                          <AppProvider>
                            <LeitourgosLayout navItems={navItems} />
                          </AppProvider>
                        </AuthGuard>
                      }
                    />
                    {/* Default redirect */}
                    <Route
                      path="/"
                      element={<Navigate to="/dashboard" replace />}
                    />
                  </Routes>
                </div>
              </Router>
            </AuthProvider>
          </QueryProvider>
        </ThemeProvider>
      </AuditLogProvider>
    </BrandProvider>
  );
};

export default App;
